<script setup lang="ts">
import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import {
  AFFILIATE_PROGRAM_PROMO_CODES_LIST_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES,
} from '@modules/affiliate-program-promo-codes/constants';
import VForm from '@modules/forms/components/VForm/VForm.vue';

import { useAffiliateProgramPromoCodesCreate } from './composables';

const {
  form,
  formSchema,
  isLoadingTrackers,
  isLoading,
  onSubmit,
  errors,
  clearError,
} = useAffiliateProgramPromoCodesCreate();
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliateProgramPromoCodesCreatePage'"
    type="form"
    :title="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES, 'CREATE_HEADER')"
  >
    <VLoader
      :loading="isLoadingTrackers"
      min-height="350px"
    >
      <VForm
        ref="form"
        :schema="formSchema"
        :submit-btn-label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES, 'CREATE_SAVE')"
        :is-loading="isLoading"
        :custom-errors="errors"
        @submit="onSubmit"
        @interacted="clearError"
      >
        <template #secondaryBtn>
          <VBackButton
            :to="{ name: AFFILIATE_PROGRAM_PROMO_CODES_LIST_ROUTE_NAME }"
            :label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES, 'CREATE_BACK')"
          />
        </template>
      </VForm>
    </VLoader>
  </VCard>
</template>
